export type RosterActionVisibility = {
  details: boolean;
  playingTime: boolean;
  reorder: boolean;
  release: boolean;
  tradeFor: boolean;
};

export const canUseRosterManagementMode = ({
  editable,
  playerCount,
  showRelease,
}: {
  editable: boolean;
  playerCount: number;
  showRelease: boolean;
}) => playerCount > 0 && (editable || showRelease);

export const getRosterActionVisibility = ({
  editable,
  managementActive,
  playerIndex,
  showRelease,
  showTradeFor,
}: {
  editable: boolean;
  managementActive: boolean;
  playerIndex: number;
  showRelease: boolean;
  showTradeFor: boolean;
}): RosterActionVisibility => {
  const hasPlayer = playerIndex >= 0;
  const showEditableControls = managementActive && editable && hasPlayer;

  return {
    details: managementActive || showTradeFor,
    playingTime: showEditableControls,
    reorder: showEditableControls,
    release: managementActive && showRelease,
    tradeFor: showTradeFor,
  };
};

export const hasRosterCardActions = (visibility: RosterActionVisibility) =>
  Object.values(visibility).some(Boolean);
